import React, { useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProvider, FetchProvider } from 'lib/providers';
import Routing from 'routing';
import store, { persistor } from './store/index';
import { SnackbarProvider } from 'notistack';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './i18n';
import 'lib/icons/all.js';
import { AnimatedSnackbar } from 'components/animations';
import LoadingPage from 'components/LoadingPage';

//  DevCatalog only in development (excluded from production bundle)
let DevCatalog = null;
if (process.env.NODE_ENV !== 'production') {
  DevCatalog = require('components/DevCatalog').DevCatalog;
}

// Component to handle the transition from HTML loader to React app
const AppWithLoaderTransition = ({ children }) => {
  useEffect(() => {
    // Hide the initial HTML loader once React is ready
    const timer = setTimeout(() => {
      const initialLoader = document.getElementById('initial-loader');
      if (initialLoader) {
        initialLoader.classList.add('hidden');
        // Remove the loader element after transition
        setTimeout(() => {
          if (initialLoader.parentNode) {
            initialLoader.parentNode.removeChild(initialLoader);
          }
        }, 300); // Match the CSS transition duration
      }
    }, 100); // Small delay to ensure smooth transition

    return () => clearTimeout(timer);
  }, []);

  return children;
};

export default function App() {
  return (
    <ReduxProvider store={store}>
      <PersistGate persistor={persistor} loading={<LoadingPage />}>
        <AppWithLoaderTransition>
          <FetchProvider>
            <ThemeProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SnackbarProvider
                  autoHideDuration={3000}
                  Components={{
                    default: AnimatedSnackbar,
                    success: AnimatedSnackbar,
                    error: AnimatedSnackbar,
                    warning: AnimatedSnackbar,
                    info: AnimatedSnackbar,
                  }}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  maxSnack={3}
                >
                  <DndProvider backend={HTML5Backend}>
                    <Routing />
                    {DevCatalog && <DevCatalog />}
                  </DndProvider>
                </SnackbarProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </FetchProvider>
        </AppWithLoaderTransition>
      </PersistGate>
    </ReduxProvider>
  );
}
